import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=794755f8&scoped=true&"
import script from "./Deny.vue?vue&type=script&lang=js&"
export * from "./Deny.vue?vue&type=script&lang=js&"
import style0 from "./Deny.vue?vue&type=style&index=0&id=794755f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794755f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794755f8')) {
      api.createRecord('794755f8', component.options)
    } else {
      api.reload('794755f8', component.options)
    }
    module.hot.accept("./Deny.vue?vue&type=template&id=794755f8&scoped=true&", function () {
      api.rerender('794755f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/errors/Deny.vue"
export default component.exports